var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { MENSAGENS } from '../../../utils';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getEstado, cadastrarEstado, alterarEstado, excluirEstado } from '../../../api';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
import InputDados from '../../../components/input_dados';
var EstadosEditar = function () {
    var services = {
        getItem: getEstado,
        cadastrarItem: cadastrarEstado,
        alterarItem: alterarEstado,
        excluirItem: excluirEstado,
    };
    var renderCamposAdicionais = function (dados, setDados, desabilitar) { return (_jsxs(_Fragment, { children: [_jsx(InputDados, { id: 'codigo_ibge', label: 'C\u00F3digo IBGE', value: dados.codigo_ibge, onChange: function (event) { return setDados(__assign(__assign({}, dados), { codigo_ibge: event.target.value })); }, mask: '99', variant: 'outlined', size: 'small', fullWidth: true, required: true, disabled: desabilitar }), _jsx(InputDados, { id: 'sigla', label: 'Sigla', value: dados.sigla, onChange: function (event) { return setDados(__assign(__assign({}, dados), { sigla: event.target.value })); }, mask: 'aa', variant: 'outlined', size: 'small', inputProps: { style: { textTransform: 'uppercase' } }, fullWidth: true, required: true, disabled: desabilitar })] })); };
    var validarExtra = function (dados) {
        if (!dados.codigo_ibge || dados.codigo_ibge.trim() === '') {
            alert("C\u00F3digo IBGE ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        if (!dados.sigla || dados.sigla.trim() === '') {
            alert("Sigla ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        return true;
    };
    var formatarDadosExtra = function (dados) { return ({
        codigo_ibge: dados.codigo_ibge ? dados.codigo_ibge.replace(/\D/g, '') : '',
        sigla: dados.sigla ? dados.sigla.toUpperCase() : '',
    }); };
    return (_jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.ESTADOS, paginaPermissao: FUNCIONALIDADES.ESTADOS, rota: ROUTES.ESTADOS, services: services, camposAdicionais: renderCamposAdicionais, validarExtra: validarExtra, formatarDadosExtra: formatarDadosExtra }));
};
export default EstadosEditar;
